import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { CommonColors } from '@material-ui/core/styles/createPalette';
import palette from './palettes';
import typography, { pxToRem } from './typography';

declare module '@material-ui/core/styles/createPalette' {
  interface CommonColors {
    ceriseRed: string;
    hitGray: string;
    manatee: string;
    flamingo: string;
    aquaHaze: string;
    cranBerry: string;
    disco: string;
    carnation: string;
    tallPoppy: string;
    geyser: string;
    deYork: string;
    concrete: string;
    tundora: string;
    azureRadiant: string;
    torchRed: string;
    eucalyptus: string;
    alabaster: string;
    mineShaft: string;
    chablis: string;
    lightGray: string;
    silver: string;
  }
}

export interface Colors extends CommonColors {
  ceriseRed: string;
  hitGray: string;
  manatee: string;
  flamingo: string;
  aquaHaze: string;
  cranBerry: string;
  disco: string;
  carnation: string;
  tallPoppy: string;
  geyser: string;
  deYork: string;
  concrete: string;
  tundora: string;
  azureRadiant: string;
  dodgerBlur: string;
  endeavour: string;
  torchRed: string;
  eucalyptus: string;
  alabaster: string;
  mineShaft: string;
  chablis: string;
  silver: string;
  redOrange: string;
  goldenrod: string;
  lightGray: string;
}

export { getLineHeight, pxToRem } from './typography';

export const theme = responsiveFontSizes(
  createMuiTheme({
    typography,
    palette,
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            fontWeight: 400,
            backgroundColor: 'white',
          },
          '.MuiButton-root': {
            textTransform: 'none',
            fontWeight: 'normal',
            fontSize: pxToRem(14),
          },
          '.MuiButton-contained.Mui-disabled': {
            backgroundColor: '#F5F5F5',
            color: '#D9D9D9',
            border: '1px solid #D9D9D9',
          },
          '.MuiSvgIcon-root': {
            fontSize: 'inherit',
          },
          '.MuiPagination-root': {
            '& > ul > li > button': {
              color: '#333',
              fontWeight: 400,
            },
          },
        },
      },
    },
  })
);
